import { CLIENTS } from "../data/siteData";
import Icon from "./Icon";

const ICONS = ["Rocket", "ShoppingBag", "Factory", "Cloud", "Landmark", "Building2"];

export default function ClientsMarquee() {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="clients-marquee" className="relative overflow-hidden border-y border-brand-blue/10 bg-brand-ice/50 py-8">
      <p className="mb-5 text-center text-xs font-semibold uppercase tracking-[0.22em] text-brand-gray">
        Trusted by 800+ esteemed clients across India
      </p>
      <div className="marquee-track gap-4 pr-4">
        {items.map((c, i) => (
          <div
            key={`${c}-${i}`}
            data-testid={`client-logo-${i}`}
            className="glass flex shrink-0 items-center gap-2.5 rounded-full px-6 py-3"
          >
            <Icon name={ICONS[i % ICONS.length]} className="h-4 w-4 text-brand-blue" />
            <span className="whitespace-nowrap font-display text-sm font-bold tracking-tight text-brand-navy/70">{c}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
